// A statement can hold pages from anywhere in the project, so where its pages stop running on
// from each other the band says so rather than pretending the file reads straight through. It is
// darker than a page's own edge, which is the only other line a band draws.
export const PageJump = () => (
  <div
    title="The pages either side of this line are not next to each other in the file"
    className="w-[3px] shrink-0 self-stretch rounded-full bg-neutral-400"
  />
)
